import { IsString, Matches } from 'class-validator';

export class ChatAddByPhoneRequest {
    @IsString()
    @Matches(/^(?:7\d{10}|375\d{9})$/, { message: 'Укажите номер РФ или РБ в международном формате, только цифры' })
    public readonly phoneNumber: string;

    constructor(data?: Partial<ChatAddByPhoneRequest>) {
        this.phoneNumber = data?.phoneNumber;
    }
}
